<template>
    <div
        :id="pageContainerId" 
        class="page" 
        data-loaded="false"
        data-page-number="pageNumber"
        style="visibility: hidden;"
    >    
        <div class="canvasWrapper">
            <canvas :id="`page${pageNumber}`" :height="pageHeight" :width="pageWidth" ></canvas>
        </div>
        <div class="textLayer"></div>
    </div>
</template>

<script>
// Vendor
import Utils from '@/lib/Utils';
import { PDFJS } from 'pdfjs-dist/web/pdf_viewer';

// Component

PDFJS.workerSrc = '../../../node_modules/pdfjs-dist/build/pdf.worker.js';

const ProjectPdfPage = {
    name: 'ProjectPdfPage',
    props: ['page', 'pageWidth', 'pageHeight', 'currentCueLayer'],
    data: function() {
        return {
            pdfRender: null,
            pageNumber: this.$props.page.pageNumber,
            pdfPage: this.$props.page.pdfPage,
            pageContainerId: 'pageContainer' + this.$props.page.pageNumber,
            selectedScale: localStorage.getItem('page-print-scale') || 1
        };
    },
    methods: {
        renderPage: function() {
            const canvas = this.$el.querySelector('.canvasWrapper canvas');

            this.canvas = this.$el.querySelector('.canvasWrapper canvas');

            const canvasContext = canvas.getContext('2d', {alpha: false});
            this.ctx = canvasContext;
            this.w = this.canvas.width;
            this.h = this.canvas.height;

            const canvasOffset = this.canvas.getBoundingClientRect();
            this.offsetX = canvasOffset.left;
            this.offsetY = canvasOffset.top;

            const viewport = Utils.getViewport(this.pdfPage, this.w, this.h, this.selectedScale);

            const transform = Utils.scalePage(this.$el, viewport, canvasContext);
            this.pdfRender = this.pdfPage.render({ canvasContext, viewport, transform })
            .then(() => {
                // Indicate that the page was loaded
                this.$el.dataset.loaded = 'true';
                return this.pdfPage.getTextContent({normalizeWhitespace: true})
                .then((textContent) => {
                    const textLayer = this.$el.querySelector('.textLayer');
                    textLayer.innerHTML = '';
                    const textLayerFactory = new PDFJS.DefaultTextLayerFactory();
                    const textLayerBuilder = textLayerFactory.createTextLayerBuilder(
                        textLayer, this.pageNumber, viewport, true);
                    textLayerBuilder.setTextContent(textContent);
                    
                    const newFontScale = 15 * this.selectedScale;
                    document.documentElement.style.setProperty('--cue-marker-font-size', `${newFontScale}px`);

                    textLayerBuilder.render();

                    this.$emit('pdfLoaded',
                        {pageText: textContent, pageNumber: this.pageNumber, viewport: viewport});
                });
            });
        }
    },
    mounted: function() {
        this.renderPage();
    }
};

export default ProjectPdfPage;
</script>

<style lang="scss">
.app-print-mode {
    .textLayer {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        overflow: hidden;
        opacity: 0.2;
        line-height: 1.0;
    }

    .textLayer.hide-text-layer{
        z-index: -1;
    }

    .textLayer > div {
        color: transparent;
        position: absolute;
        white-space: pre;
        cursor: text;
        -webkit-transform-origin: 0% 0%;
        -moz-transform-origin: 0% 0%;
        -o-transform-origin: 0% 0%;
        -ms-transform-origin: 0% 0%;
        transform-origin: 0% 0%;
    }

    .textLayer::selection { background: rgb(0,0,255); }
    .textLayer::-moz-selection { background: rgb(0,0,255); }
}
</style>


// WEBPACK FOOTER //
// pdf-page.vue?401224de